export const debounce = <T extends (...args: any[]) => unknown>(callback: T, delay = 400): ((...args: Parameters<T>) => void) => {
  let timeoutID: any
  return (...args) => {
    clearTimeout(timeoutID)
    timeoutID = setTimeout(() => callback(...args), delay)
  }
}
